import { IRootState, RootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
import { IAgendaService, AgendaService } from '@/services';
//@ts-ignore
import { AppointmentDto, IAppointment } from '@/models/appointment';
import { IAppointmentParameter, AppointmentParameterDto } from '../../models/appointment';
import { AGENDA_LOADERS } from './agenda-types.store';

export interface IAgendaState<TService = any> extends IRootState<IAgendaService> {
  appointments?: AppointmentDto[];
  appointment?: AppointmentDto;
  originUpdatingAppointment?: AppointmentDto;
  originAppointment?: AppointmentDto;
  appointmentParameter?: IAppointmentParameter;
}
export class AgendaState extends RootState implements IAgendaState<IAgendaService> {
  /**
   *
   */
  appointments: IAppointment[];
  appointment: IAppointment;
  originAppointment: IAppointment;
  originUpdatingAppointment?: AppointmentDto;
  appointmentParameter: IAppointmentParameter;
  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new AgendaService;
    this.appointments = [];
    this.appointment = new AppointmentDto;
    this.originUpdatingAppointment = {};
    this.appointmentParameter = new AppointmentParameterDto({
      block: [],
      ic: [],
      type: null,
    })
    this.loaders= new Map([
      [AGENDA_LOADERS.RESOURCES,false]
    ])
  }
}


// WEBPACK FOOTER //
// ./src/store/agenda/agenda-state.store.ts